import React from "react";

import { useAuth } from "@/hooks/useAuth";

import { MenuItem } from "@/components/molecules";

import { TRoute } from "@/types";

interface IMenuProps {
	routes: TRoute[];
	isReduced?: boolean;
}

export const Menu: React.FC<IMenuProps> = ({ isReduced, routes }) => {
	const { hasRole } = useAuth();
	return (
		<div className="flex w-full flex-col items-center gap-4">
			{routes?.map((route) => {
				if (route.hidden) return null;
				if (route.roles && !hasRole(route.roles, route.needAllRoles))
					return false;
				const path = Array.isArray(route.path)
					? route.path[0]
					: route.path;
				return (
					<MenuItem
						{...route}
						key={path}
						to={path}
						isReduced={isReduced}
					>
						{route.title}
					</MenuItem>
				);
			})}
		</div>
	);
};
